import { Locale } from '../helpers/LangHelper';
import BaseModel from './BaseModel';

class PageModel extends BaseModel {
    constructor() {
        super({ modelName: 'page' });
    }

    getAll = async ({
        includeUnpublished = false,
        includeDraft = false,
        fields,
        limit,
        offset,
        locale,
    }: {
        includeUnpublished?: boolean;
        includeDraft?: boolean;
        fields?: string;
        limit?: number;
        offset?: number;
        locale?: Locale;
    }) => {
        const draft = includeDraft ?? 'draft';

        let paging = {};
        if (Number.isInteger(limit) && Number.isInteger(offset)) {
            paging = {
                limit,
                offset,
            };
        }

        let query: any = {
            published: {
                $ni: ['archived', draft],
            },
            userAttributes: {},
        };
        if (locale) {
            query.userAttributes.locale = locale;
        }

        const pages = await this.builder.getAll(this.modelName, {
            options: { noTargeting: true, includeUnpublished, locale },
            query,
            fields,
            omit: 'data.state',
            ...paging,
        });

        return pages;
    };

    getPage = async (url: string, locale: Locale) => {
        return this.builder
            .get(this.modelName, {
                options: {
                    locale,
                },
                userAttributes: {
                    urlPath: url,
                    locale,
                },
            })
            .toPromise();
    };
}

export default new PageModel();
